import React, { useState } from 'react';
import logo from './vijaya logo.png';

const HeaderMobile = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  const toggleMenu = () => {
    setMenuOpen(prevState => !prevState);
  };

  return (
    <header
      className="header-mobile d-block d-lg-none"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        background: '#fff',
        zIndex: 1050,
        boxShadow: '0 2px 5px rgba(0, 0, 0, 0.1)',
      }}
    >
      <div
        className="header-mobile__bar"
        style={{
          height: '60px',
          display: 'flex',
          alignItems: 'center',
          padding: '0 15px',
        }}
      >
        <div className="container-fluid">
          <div className="header-mobile-inner d-flex justify-content-between align-items-center">
            <a className="logo" href="index.html">
              <img src={logo} alt="VDC" />
            </a>
            <button
              className={`hamburger hamburger--slider ${menuOpen ? 'is-active' : ''}`}
              type="button"
              onClick={toggleMenu}
            >
              <span className="hamburger-box">
                <span className="hamburger-inner"></span>
              </span>
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Navigation */}
      <nav
        className={`navbar-mobile ${menuOpen ? 'open' : ''}`}
        style={{
          position: 'fixed',
          top: '60px',
          left: 0,
          width: '100%',
          backgroundColor: '#fff',
          zIndex: 1049,
          display: menuOpen ? 'block' : 'none',
          transition: 'all 0.3s ease',
        }}
      >
        <div className="container-fluid">
          <ul className="navbar-mobile__list list-unstyled">
            <li className="has-sub">
              <a className="js-arrow" href="./dashboard">
                <i className="fas fa-tachometer-alt"></i>Dashboard
              </a>
            </li>
            <li>
              <a href="./manage_users">
                <i className="fas fa-chart-bar"></i>Users
              </a>
            </li>
            <li>
              <a href="./manage_candidates">
                <i className="fas fa-users"></i>Candidates
              </a>
            </li>
            <li>
              <a href="./manage_dresstype">
                <i className="fas fa-shopping-bag"></i>Dress Type
              </a>
            </li>
            <li>
              <a href="./manage_dresssize">
                <i className="fas fa-shopping-bag"></i>Dress Size
              </a>
            </li>
            <li>
              <a href="./manage_dresscolor">
                <i className="fas fa-shopping-bag"></i>Dress Color
              </a>
            </li>
          </ul>
        </div>
      </nav>
    </header>
  );
};

export default HeaderMobile;
